(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(() => {
  const init = form => {
    if(form.dataset.pmReady)return;
    form.dataset.pmReady='true';
    const rows=Array.from(form.querySelectorAll('[data-design]'));
    const checkout=form.querySelector('[name="checkout"]');
    const message=form.querySelector('[data-cart-repair]');
    let mismatch=false;
    const designs=[...new Set(rows.map(r=>r.dataset.design).filter(Boolean))];
    for(const design of designs){
      const parents=rows.filter(r=>r.dataset.print==='false' && r.dataset.design===design);
      const children=rows.filter(r=>r.dataset.print==='true' && r.dataset.design===design);
      const input=row=>row.querySelector('[name="updates[]"]');
      const sync=()=>{
        let left=parents.reduce((sum,r)=>sum+Math.max(0,Number(input(r).value)||0),0);
        children.forEach((child,index)=>{const target=index===children.length-1?left:Math.min(left,Math.max(0,Number(input(child).value)||0));if(Number(input(child).value)!==target){input(child).value=target;mismatch=true;}left-=target;});
      };
      sync();parents.forEach(parent=>input(parent).addEventListener('input',sync));
    }
    if(mismatch){checkout.disabled=true;message.hidden=false;}
  };
  document.querySelectorAll('[data-pm-cart]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-pm-cart]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-printed-bag"]) return;
  try {
    
document.querySelectorAll('[data-pm-bag]').forEach(root=>{
 const form=root.querySelector('form'), file=root.querySelector('input[type=file]'), art=root.querySelector('[data-art]'), size=root.querySelector('[data-size]'), y=root.querySelector('[data-y]'), error=root.querySelector('[data-error]');let objectURL=null,ready=false;
 const position=()=>{art.style.width=size.value+'%';art.style.top=y.value+'%';root.querySelector('[data-placement]').value='Breedte '+size.value+'%, bovenkant '+y.value+'% van voorbeeld; horizontaal gecentreerd';};
 size.addEventListener('input',position);y.addEventListener('input',position);
 file.addEventListener('change',()=>{ready=false;art.hidden=true;file.setCustomValidity('');error.textContent='';if(objectURL)URL.revokeObjectURL(objectURL);const f=file.files[0];if(!f)return;if(!['image/png','image/jpeg','image/webp'].includes(f.type)||f.size>10*1024*1024){file.setCustomValidity(error.dataset.message);error.textContent=error.dataset.message;return;}objectURL=URL.createObjectURL(f);art.onload=()=>{ready=true;art.hidden=false;};art.onerror=()=>{ready=false;file.setCustomValidity(error.dataset.message);error.textContent=error.dataset.message;};art.src=objectURL;});
 form.addEventListener('submit',e=>{if(!ready){e.preventDefault();error.textContent=error.dataset.message;return;}const b=form.querySelector('button');b.disabled=true;b.textContent=b.dataset.busy;});
 window.addEventListener('pageshow',e=>{if(e.persisted)location.reload();});
});

  } catch(e) { console.error(e); }
})();
})();
